module.exports = __webpack_public_path__ + "static/media/search.7bffa8f9.svg";